// Catch-all entry. Matches every URL not already claimed by a sibling
// page.tsx. Dynamically loads the client-side React Router app so the entire
// SPA is rendered client-only (no SSR), matching axiom.trade's architecture.

'use client';

import dynamic from 'next/dynamic';

const ClientRouterApp = dynamic(() => import('@/client-router/App'), {
  ssr: false,
  loading: () => null,
});

export default function CatchAll() {
  return <ClientRouterApp />;
}
